import { DICE_FORMULA_LIMIT, DICE_WIN_CHANCE_PRECISION, RANGE_TYPE } from '../constants';
import {
  parseNumberByPrecision,
  parseNumberPrecisionByDoteCount,
} from '../../../../core/helpers/parseNumberByPrecision';
import { userInfoStore } from '../../../../store/userInfoStore';

export const getRangeNumberCountFromMultiplier = {
  [RANGE_TYPE.Under]: (odd, rtp) => {
    const role = (rtp * 100) / odd;
    return Math.round(parseNumberPrecisionByDoteCount(1, role.toFixed(2), 2));
  },
  [RANGE_TYPE.Over]: (odd, rtp) => {
    const role = 100 - (rtp * 100) / odd;
    return Math.round(parseNumberPrecisionByDoteCount(1, role.toFixed(2), 2));
  },
};

export const getMultiplierLimitsByRtp = (rtp) => {
  return {
    minBet:
      DICE_FORMULA_LIMIT.minBet * rtp < 1
        ? DICE_FORMULA_LIMIT.minBet
        : DICE_FORMULA_LIMIT.minBet * rtp,
    maxBet: DICE_FORMULA_LIMIT.maxBet * rtp,
  };
};

export const getWinChanceLimitsByRtp = (multiPlayerLimit) => {
  return {
    minBet: parseNumberByPrecision(
      100,
      userInfoStore.rtp / multiPlayerLimit.minBet,
      DICE_WIN_CHANCE_PRECISION
    ),
    maxBet: parseNumberByPrecision(
      100,
      userInfoStore.rtp / multiPlayerLimit.maxBet,
      DICE_WIN_CHANCE_PRECISION
    ),
  };
};

export const getOddByBetType = {
  [RANGE_TYPE.Under]: (number, rtp) => {
    return (rtp * 100) / number;
  },
  [RANGE_TYPE.Over]: (number, rtp) => {
    return (rtp * 100) / parseNumberPrecisionByDoteCount(1, 100 - number, 4);
  },
};
export function detectLegendActivity(rangeValue, legendValue, rangeType) {
  if (rangeType === RANGE_TYPE.Under) {
    return rangeValue >= legendValue ? 'active' : '';
  }
  return rangeValue <= legendValue ? 'active' : '';
}
